// Session timeout in minutes
const SESSION_TIMEOUT_MINUTES = parseInt(
  process.env.REACT_APP_SESSION_TIMEOUT || '60',
  10
);

export const SESSION_CONFIG = {
  // Timeout values in milliseconds
  TIMEOUT_DURATION: SESSION_TIMEOUT_MINUTES * 60 * 1000, // Convert to milliseconds
  WARNING_DURATION: 60 * 1000, // 1 minute warning before timeout

  // Session refresh settings
  REFRESH_THRESHOLD: 5 * 60 * 1000, // Refresh token when 5 minutes left
  REFRESH_INTERVAL: 30 * 1000, // Check session every 30 seconds

  // Activity tracking
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
  ],

  // Storage keys
  STORAGE_KEYS: {
    TOKEN: 'skai1_access_token',
    REFRESH_TOKEN: 'skai1_refresh_token',
    USER_DATA: 'skai1_user_data',
    LAST_ACTIVITY: 'skai1_last_activity',
    SESSION_START: 'skai1_session_start',
  },

  // Session states
  STATES: {
    ACTIVE: 'active',
    WARNING: 'warning',
    EXPIRED: 'expired',
    IDLE: 'idle',
  },

  // Timeouts by environment
  TIMEOUTS_BY_ENV: {
    development: 30 * 60 * 1000, // 30 minutes in dev
    production: SESSION_TIMEOUT_MINUTES * 60 * 1000,
    test: 5 * 60 * 1000, // 5 minutes in test
  },
};
